import { ReactNode, createContext, useContext, useState } from 'react';

interface CheckoutContextData {
  isLoadingPurchase: boolean;
  isSuccessPurchase: boolean;
  isErrorPurchase: boolean;
  setIsLoadingPurchase: (value: boolean) => void;
  setIsSuccessPurchase: (value: boolean) => void;
  setIsErrorPurchase: (value: boolean) => void;
}

const CheckoutContext = createContext<CheckoutContextData>({} as CheckoutContextData);

interface CheckoutProviderProps {
  children: ReactNode;
}

export function CheckoutProvider({ children }: CheckoutProviderProps) {
  const [isLoadingPurchase, setIsLoadingPurchase] = useState(false);
  const [isSuccessPurchase, setIsSuccessPurchase] = useState(false);
  const [isErrorPurchase, setIsErrorPurchase] = useState(false);

  return (
    <CheckoutContext.Provider
      value={{
        isLoadingPurchase,
        isSuccessPurchase,
        isErrorPurchase,
        setIsLoadingPurchase,
        setIsSuccessPurchase,
        setIsErrorPurchase,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
}

export function useCheckout() {
  const context = useContext(CheckoutContext);
  
  if (!context) {
    throw new Error('useCheckout must be used within a CheckoutProvider');
  }
  
  return context;
}
